import { combineReducers } from 'redux';
import appointments from './modules/appointments/reducer';
import staff from './modules/staff/reducer';

export default combineReducers({
  appointments,
  staff,
});
